export const isValidPill = (entry) =>
  Boolean(entry?.url?.trim() && (entry.logo?.trim() || entry.text?.trim()));

export const filterAndSortPills = (entries, now = new Date()) => {
  const ts = now instanceof Date ? now.getTime() : new Date(now).getTime();

  return entries
    .filter((entry) => {
      if (!isValidPill(entry)) return false;
      if (entry.starts_at && new Date(entry.starts_at).getTime() > ts)
        return false;
      if (entry.ends_at && new Date(entry.ends_at).getTime() <= ts)
        return false;
      return true;
    })
    .sort((a, b) => {
      const aHasDate = Boolean(a.starts_at);
      const bHasDate = Boolean(b.starts_at);
      if (aHasDate && !bHasDate) return -1;
      if (!aHasDate && bHasDate) return 1;
      if (!aHasDate && !bHasDate) return 0;
      return new Date(b.starts_at).getTime() - new Date(a.starts_at).getTime();
    });
};
